export const RAPPORT = {
    SET_ITEMS: 'SET_RAPPORT_ITEMS',
    ADD_ITEMS: 'ADD_RAPPORT_ITEMS',
    RESET_ITEMS: 'RAPPORT_RESET_ITEMS',

    SET_PAGE: 'SET_RAPPORT_PAGE',
    SET_NB_OF_PAGES: 'SET_RAPPORT_NB_OF_PAGES',
    SET_SCROLL: 'SET_RAPPORT_SCROLL',

    SET_FILTER_SITE: 'SET_RAPPORT_FILTER_SITE',
    SET_FILTER_GROUPE: 'SET_RAPPORT_FILTER_GROUPE',
    SET_FILTER_SOUS_GROUPE: 'SET_RAPPORT_FILTER_SOUS_GROUPE',
    SET_FILTER_EQUIPEMENT: 'SET_RAPPORT_FILTER_EQUIPEMENT',
    ADD_FILTER_SITE: 'ADD_RAPPORT_FILTER_SITE',
    REMOVE_FILTER_SITE: 'REMOVE_RAPPORT_FILTER_SITE',
    SET_FILTER_DOCUMENT_DATE_FROM: 'SET_RAPPORT_FILTER_DOCUMENT_DATE_FROM',
    SET_FILTER_DOCUMENT_DATE_TO: 'SET_RAPPORT_FILTER_DOCUMENT_DATE_TO',

    SET_SORT: 'SET_RAPPORT_SORT',
    SET_COUNT: 'SET_RAPPORT_COUNT',

    SET_ERROR: 'SET_RAPPORT_ERROR',
    SET_IS_LOADING: 'SET_RAPPORT_IS_LOADING',
    SET_ZIP_IS_LOADING: 'SET_ZIP_IS_LOADING',

    RESET: 'RESET_RAPPORT',
    SET_NB_RAPPORT: 'SET_NB_RAPPORT'
};
